import React, { createContext, useContext, useReducer } from 'react';
const CardContext = createContext();

const CardContextProvider = ({ children, initialState = {}, reducer }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const value = { state, dispatch };
  return <CardContext.Provider value={value}>{children}</CardContext.Provider>;
};

const useCardContext = () => {
  const context = useContext(CardContext);
  if (context === undefined) {
    throw new Error('useCardContext must be used within a CardContextProvider');
  }
  return context;
};

export { CardContextProvider, useCardContext, CardContext };
